export default __webpack_public_path__ + "5757390018b6e0fa047f95e0ae89379a.png";